/**
 * Renders an emoji string. If the emoji is a flag emoji (regional indicator symbols),
 * renders it as an SVG flag image for cross-platform consistency (Windows doesn't render flag emojis).
 */

// Match flag emojis: two regional indicator symbol letters (U+1F1E6..U+1F1FF)
const FLAG_REGEX = /^[\u{1F1E6}-\u{1F1FF}]{2}$/u;

function flagEmojiToCountryCode(flag: string): string {
  const codePoints = [...flag];
  return codePoints.map(cp => String.fromCharCode(cp.codePointAt(0)! - 0x1F1E6 + 65)).join('');
}

interface EmojiOrFlagProps {
  emoji: string;
  className?: string;
  size?: number;
}

export default function EmojiOrFlag({ emoji, className, size = 18 }: EmojiOrFlagProps) {
  if (!emoji) return null;

  if (FLAG_REGEX.test(emoji)) {
    const code = flagEmojiToCountryCode(emoji);
    return (
      <img
        src={`/flags/${code}.svg`}
        alt={emoji}
        width={size}
        height={Math.round(size * 0.75)}
        className={className ?? 'inline-block rounded-[2px] align-middle'}
      />
    );
  }

  return <span className={className}>{emoji}</span>;
}
